/** @format */

export const deepClone = (obj: any) => {
	if (typeof obj !== 'object') {
		return obj;
	}
	if (obj === null) {
		return null;
	}

	const newObj = Array.isArray(obj) ? [] : {};
	for (const key in obj) {
		newObj[key] = deepClone(obj[key]);
	}
	return newObj;
};

export const flat = <T extends any[]>(arr: T, children = 'children'): T =>
	arr.reduce((arr, itm) => {
		if (itm[children]?.length) {
			return [...arr, itm, ...flat(itm[children])];
		} else {
			return [...arr, itm];
		}
	}, []);

/**
 * 根据keys选择对象中的属性
 * @value 对象
 * @keys 选择的key，以`.`分隔
 * @returns 选择的对象
 */
export const chain = (value: Record<string, any>, keys: string) =>
	keys.split('.').reduce((val, item) => {
		return val[item] || '';
	}, value);

export const commonRegExp = {
	number: '^\\d+(\\.\\d+)?$',
	letter: '^[A-Za-z]+$',
	letterAndNumber: '^[A-Za-z0-9]+$',
	mobilePhone: '^[1][3-9][0-9]{9}$',
	idCard:
		'^(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}$)$',
	ip: '^(((25[0-5]|2[0-4]\\d|1?\\d?\\d).){3}(25[0-5]|2[0-4]\\d|1?\\d?\\d))$',
	letterStartNumberIncluded: '^[A-Za-z]+[A-Za-z\\d]*$',
	noChinese: '^[^\u4e00-\u9fa5]+$',
	chinese: '^[\u4e00-\u9fa5]+$',
	email: '^([-_A-Za-z0-9.]+)@([_A-Za-z0-9]+\\.)+[A-Za-z0-9]{2,3}$',
	url: '^([hH][tT]{2}[pP]:\\/\\/|[hH][tT]{2}[pP][sS]:\\/\\/)(([A-Za-z0-9-~]+)\\.)+([A-Za-z0-9-~\\/])+$',
};
